(() => {
  const wire = (scope) => {
    scope.querySelectorAll('.menu-drawer summary.menu-drawer__menu-item').forEach((summary) => {
      if (!summary.getAttribute('aria-label')) {
        const label = summary.textContent.trim();
        if (label) summary.setAttribute('aria-label', label);
      }
    });
    const active = scope.querySelector('.bne-collection-tabs [aria-current="page"]');
    const tabs = active?.closest('.bne-collection-tabs');
    if (tabs && tabs.scrollWidth > tabs.clientWidth) {
      tabs.scrollLeft = Math.max(0, active.offsetLeft - tabs.offsetLeft - 18);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wire(document), { once: true });
  } else {
    wire(document);
  }
  document.addEventListener('shopify:section:load', (event) => wire(event.target));
})();
